// @flow
import React from 'react';
import { NavLink } from 'react-router-dom';
import Typography from '@justpark/ui/src/components/Typography';

import '../../../static/scss/components/ui/link.scss';

type Props = {
  to: string,
  children: any
};

const Link = ({ to, children }: Props) => (
  <Typography size="secondary" className="c-link">
    <NavLink to={to}>{children}</NavLink>
  </Typography>
);

export default Link;
